/** Shared MUI Tabs container styling for filter/tab bars in admin views. */

export const getThemedTabsSx = (overrides = {}) => ({
  bgcolor: "var(--app-surface-alt)",
  borderBottom: "1px solid",
  borderColor: "divider",
  ...overrides,
  "& .MuiTab-root": {
    color: "text.secondary",
    opacity: 1,
    textTransform: "none",
    minHeight: 48,
    ...overrides["& .MuiTab-root"],
  },
  "& .MuiTab-root.Mui-selected": {
    color: "primary.main",
    ...overrides["& .MuiTab-root.Mui-selected"],
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "primary.main",
    ...overrides["& .MuiTabs-indicator"],
  },
});
